import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import enTranslations from './locales/en.json';
import ruTranslations from './locales/ru.json';

const resources = {
  en: {
    translation: enTranslations
  },
  ru: {
    translation: ruTranslations
  }
};

// Function to get initial language
const getInitialLanguage = () => {
  // First check localStorage
  const savedLanguage = localStorage.getItem('language');
  if (savedLanguage && (savedLanguage === 'ru' || savedLanguage === 'en')) {
    return savedLanguage;
  }
  
  // Then check URL parameter
  const urlParams = new URLSearchParams(window.location.search);
  const langParam = urlParams.get('lang');
  if (langParam === 'ru' || langParam === 'en') {
    return langParam;
  }
  
  // Default to Russian
  return 'ru';
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    react: {
      useSuspense: false, // Disable suspense for better compatibility
    },
  });

export default i18n; 